const UNAVAILABLE = 'tcs:unavailable';
const FALLBACK = 'tcs:fallback';
const WITHOUT_RANK = 'tcs:without_rank';
const WITH_RANK = 'tcs:with_rank';

function determineTcsMode(enabled, experimentValue) {
    if (enabled !== true) {
        return UNAVAILABLE;
    }

    switch (experimentValue) {
        case 1:
            return WITHOUT_RANK;
        case 2:
            return WITH_RANK;
        default:
            return FALLBACK;
    }
}

export {UNAVAILABLE, FALLBACK, WITHOUT_RANK, WITH_RANK, determineTcsMode};
